//Created context to make history & updateCallHistory available anywhere in our component tree.
import { createContext, useContext } from "react";
import { useCallHistory } from "../hooks/useCallHistory";

const CallHistoryContext = createContext();

export let externalUpdateCallHistory = null; // global reference
export let externalGetCallHistoryItem = null; //global reference

export function CallHistoryProvider({ children }) {
  const { history, updateCallHistory } = useCallHistory();

  // expose updater for plain JS files
  externalUpdateCallHistory = updateCallHistory;
  //expose getter for plain JS files
  externalGetCallHistoryItem = (id) => history.find((item) => item.id === id) || null;

  return (
    <CallHistoryContext.Provider value={{ history, updateCallHistory }}>
      {children}
    </CallHistoryContext.Provider>
  );
}

export function useCallHistoryContext() {
  return useContext(CallHistoryContext);
}
